import { render, staticRenderFns } from "./CustomInputColor.vue?vue&type=template&id=8beb0020&scoped=true&"
import script from "./CustomInputColor.vue?vue&type=script&lang=js&"
export * from "./CustomInputColor.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputColor.vue?vue&type=style&index=0&id=8beb0020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beb0020",
  null
  
)

export default component.exports